import {
  Image,
  ImageBackground,
  Modal,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { AppImages } from "../../../../utility/AppImages";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../../Api/configs";
import { ShowLoader } from "../../../../common/ShowLoader";
import {
  createTransaction,
  fetchPaymentBeltExchange,
  fetchPaymentRequestSell,
  fetchPaymentRequestConvert,
} from "../../../../services/profileAPI";
import { handleApiError } from "../../../../services/errorHandler";
import UpgradeComponent from "../../../../Components/home-common-components/UpgradeComponent";
import { useAuthProvider } from "../../../../context/AuthContext";
import Separator from "../../../../Components/Separator";
import { CommonButton } from "../../../../common/CommonButton";
import BeltExchangeSuccessModal from "./BeltExchangeSuccessModal";
import CreditConversionSuccessModal from "./CreditConversionSuccessModal";

export default function SaleBeltModal(props) {
  const {
    setArrBeltMedalType,
    showModal = false,
    userData,
    setShowModal,
    sellBeltsData = {},
    numberOfBelts = 0,
    accessToken,
    setRefreshAPICall,
    arrBeltMedalType = [],
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [amount, setAmount] = useState(numberOfBelts);
  const [showLoader, setShowLoader] = useState(false);
  const [paymentBeltExchangeData, setPaymentBeltExchangeData] = useState(null);
  const [beltTokenValue, setBeltTokenValue] = useState(0);
  // const [sellBeltsValue, setSellBeltsValue] = useState(sellBeltsData);
  const [credit, setCredit] = useState(0);
  useEffect(() => {
    setCredit(sellBeltsData.token * amount);
  }, [amount]);
  const paymentBeltExchangeAPI = async (AccessToken) => {
    setShowLoader(true);

    try {
      const response = await fetchPaymentBeltExchange(AccessToken);
      setShowLoader(false);

      if (response.statusCode === 200) {
        setPaymentBeltExchangeData(response);

        if (sellBeltsData.title === "Bronze") {
          setBeltTokenValue(response.exchangeRates.bronze);
          // setSellBeltsValue(response.sellRates.bronze);
        } else if (sellBeltsData.title === "Silver") {
          setBeltTokenValue(response.exchangeRates.silver);
          // setSellBeltsValue(response.sellRates.silver);
        } else if (sellBeltsData.title === "Gold") {
          setBeltTokenValue(response.exchangeRates.gold);
          // setSellBeltsValue(response.sellRates.gold);
        } else if (sellBeltsData.title === "Platinum") {
          setBeltTokenValue(response.exchangeRates.platinum);
          // setSellBeltsValue(response.sellRates.platinum);
        }
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    paymentBeltExchangeAPI(accessToken);
  }, []);

  const { isActiveSubscriptionFound } = useAuthProvider();

  const [count, setCount] = useState(0);
  const [activeTab, setActiveTab] = useState(0); // 0 for Credit, 1 for Lower belt

  // Lower belt conversion states
  const [fromBelt, setFromBelt] = useState(sellBeltsData.title || "Silver");
  const [toBelt, setToBelt] = useState("Bronze");
  const [lowerBeltCount, setLowerBeltCount] = useState(0);
  const [showToDropdown, setShowToDropdown] = useState(false);

  // Success modal states
  const [showBeltExchangeSuccess, setShowBeltExchangeSuccess] = useState(false);
  const [showCreditConversionSuccess, setShowCreditConversionSuccess] =
    useState(false);
  const [conversionSuccessData, setConversionSuccessData] = useState({
    fromBeltImage: null,
    toBeltImage: null,
    fromBeltName: "",
    toBeltName: "",
    fromAmount: 0,
    toAmount: 0,
    creditsAmount: 0,
    currencyValue: "",
  });

  // Button loading states
  const [isConvertingToCredit, setIsConvertingToCredit] = useState(false);
  const [isConvertingBelts, setIsConvertingBelts] = useState(false);

  // Check if current belt can be converted (Bronze cannot be converted down)
  const canConvertDown = sellBeltsData.title !== "Bronze";

  // Get available "From" belts (only belts user actually has)
  const getAvailableFromBelts = () => {
    const availableBelts = [];

    // Check each belt type and only include if user has them (value > 0)
    arrBeltMedalType.forEach((belt) => {
      if (
        belt.title &&
        belt.value > 0 &&
        ["Silver", "Gold", "Platinum"].includes(belt.title)
      ) {
        availableBelts.push(belt.title);
      }
    });

    return availableBelts;
  };

  // Get belt data by title
  const getBeltDataByTitle = (title) => {
    return (
      arrBeltMedalType.find((belt) => belt.title === title) || { value: 0 }
    );
  };

  // Get available "To" belts based on "From" selection
  const getAvailableToBelts = (from) => {
    switch (from) {
      case "Platinum":
        return ["Gold", "Silver", "Bronze"];
      case "Gold":
        return ["Silver", "Bronze"];
      case "Silver":
        return ["Bronze"];
      default:
        return [];
    }
  };

  // Sync fromBelt with sellBeltsData when it changes
  useEffect(() => {
    if (sellBeltsData.title) {
      setFromBelt(sellBeltsData.title);
      // Set default To belt based on From belt
      const availableTo = getAvailableToBelts(sellBeltsData.title);
      if (availableTo.length > 0) {
        setToBelt(availableTo[0]);
      }
      // If Bronze is selected and user is on Lower belt tab, switch to Credit tab
      if (sellBeltsData.title === "Bronze" && activeTab === 1) {
        setActiveTab(0);
      }
    }
  }, [sellBeltsData]);

  // Update To belt when From belt changes
  useEffect(() => {
    const availableTo = getAvailableToBelts(fromBelt);
    if (availableTo.length > 0 && !availableTo.includes(toBelt)) {
      setToBelt(availableTo[0]);
    }
    // Reset count when changing From belt
    setLowerBeltCount(0);
  }, [fromBelt]);

  const increment = () => setCount((prev) => prev + 1);
  const decrement = () => {
    if (count > 0) {
      setCount((prev) => prev - 1);
    }
  };

  const incrementLowerBelt = () => setLowerBeltCount((prev) => prev + 1);
  const decrementLowerBelt = () => {
    if (lowerBeltCount > 0) {
      setLowerBeltCount((prev) => prev - 1);
    }
  };

  // Static conversion rates (will be replaced with API later)
  // 1 Platinum = 10 Gold = 100 Silver = 1000 Bronze
  const conversionRates = {
    Platinum: { Gold: 10, Silver: 100, Bronze: 1000 },
    Gold: { Silver: 10, Bronze: 100 },
    Silver: { Bronze: 10 },
  };

  const getConversionRate = (from, to) => {
    return conversionRates[from]?.[to] || 0;
  };

  const calculateConvertedAmount = () => {
    const rate = getConversionRate(fromBelt, toBelt);
    return lowerBeltCount * rate;
  };

  // Helper function to get belt image based on belt name
  const getBeltImage = (beltName) => {
    switch (beltName) {
      case "Bronze":
        return AppImages.icBronzeBelt;
      case "Silver":
        return AppImages.icSilverBelt;
      case "Gold":
        return AppImages.icGoldBelt;
      case "Platinum":
        return AppImages.icPlatinumBelt;
      default:
        return AppImages.icBronzeBelt;
    }
  };

  // Convert belts API function
  const convertBeltsAPI = async () => {
    // Validate count
    if (lowerBeltCount === 0) {
      toast.error("Please select at least 1 belt to convert");
      return;
    }

    // Validate that user has enough belts
    if (lowerBeltCount > sellBeltsData.value) {
      toast.error(
        `You only have ${sellBeltsData.value} ${fromBelt} belts available`
      );
      return;
    }

    setIsConvertingBelts(true);

    const conversionDetails = {
      userID: userData.username,
      fromBeltType: fromBelt,
      toBeltType: toBelt,
      amount: lowerBeltCount,
    };

    try {
      const response = await fetchPaymentRequestConvert(
        userData.AccessToken,
        conversionDetails
      );
      setIsConvertingBelts(false);

      if (response.statusCode === 200) {
        const convertedAmount = calculateConvertedAmount();

        // Create transaction for belt exchange with complete conversion info
        await createNewTransaction(
          "",
          lowerBeltCount,
          `${lowerBeltCount} ${fromBelt} to ${convertedAmount} ${toBelt}`
        );

        // Set success modal data
        setConversionSuccessData({
          fromBeltImage: sellBeltsData.image,
          toBeltImage: getBeltImage(toBelt),
          fromBeltName: fromBelt,
          toBeltName: toBelt,
          fromAmount: lowerBeltCount,
          toAmount: convertedAmount,
          creditsAmount: 0,
          currencyValue: "",
        });

        // Show success modal (don't close main modal yet - will close when success modal closes)
        setShowBeltExchangeSuccess(true);
        setLowerBeltCount(0);
        setRefreshAPICall(true);
      } else {
        toast.error(
          response.error || "An error occurred during the belt conversion"
        );
      }
    } catch (error) {
      setIsConvertingBelts(false);
      toast.error(error.message || "Failed to convert belts");
    }
  };

  return (
    <>
      <Modal
        animationType="fade"
        transparent={true}
        visible={showModal && !showBeltExchangeSuccess && !showCreditConversionSuccess}
        onRequestClose={onCloseClick}
      >
        <View style={styles.container}>
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "center",
          }}
          style={styles.scrollView}
        >
          <LinearGradient
            colors={["#111827", "#000"]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={styles.mainView}
          >
            {/* Header view */}
            <View style={styles.headerView}>
              <View
                style={{
                  flex: 1,
                  alignSelf: "center",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={[AppFontStyle.BOLD_ANYBODY_24, styles.headerText]}>
                  Convert belts
                </Text>
                <TouchableOpacity onPress={onCloseClick} activeOpacity={0.5}>
                  <Image
                    source={AppImages.icCloseWhite}
                    style={{
                      height: 28,
                      width: 28,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
              </View>
            </View>
            <Separator
              color={AppColors.gray_838383}
              height={1}
              marginTop={8}
              marginBottom={0}
              marginHorizontal={0}
            />

            {/* Tabs */}
            <View style={{ marginTop: 16, marginBottom: 8 }}>
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_16, { marginBottom: 12 }]}
              >
                Convert your Belts to
              </Text>
              <LinearGradient
                colors={["#1F2937", "#111827"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                style={{
                  flexDirection: "row",
                  gap: 18,
                  padding: 8,
                  borderRadius: 4,
                  alignItems: "flex-start",
                }}
              >
                <TouchableOpacity
                  style={[
                    styles.tabButton,
                    activeTab === 0 && styles.activeTabButton,
                  ]}
                  onPress={() => setActiveTab(0)}
                >
                  <Text
                    style={[
                      AppFontStyle.SEMIBOLD_ANYBODY_16,
                      activeTab === 0 && { color: AppColors.white },
                    ]}
                  >
                    Credit
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[
                    styles.tabButton,
                    activeTab === 1 && styles.activeTabButton,
                    !canConvertDown && styles.disabledTabButton,
                  ]}
                  onPress={() => {
                    if (canConvertDown) {
                      setActiveTab(1);
                    }
                  }}
                  disabled={!canConvertDown}
                >
                  <Text
                    style={[
                      AppFontStyle.SEMIBOLD_ANYBODY_16,
                      activeTab === 1 && { color: AppColors.white },
                      !canConvertDown && { color: "#6B7280" },
                    ]}
                  >
                    Lower belt
                  </Text>
                </TouchableOpacity>
              </LinearGradient>
            </View>

            <View style={{ gap: 22, marginVertical: 22, overflow: "visible" }}>
              {/* Credit Tab Content */}
              {activeTab === 0 && (
                <>
                  <View style={{ alignItems: "center" }}>
                    {" "}
                    <View
                      style={{
                        width:
                          deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                            ? "100%"
                            : 423,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <View style={{ gap: 10 }}>
                        <LinearGradient
                          colors={[
                            "rgba(31, 41, 55, 0.50)",
                            "rgba(17, 24, 39, 0.50)",
                          ]}
                          start={{ x: 0, y: 0 }}
                          end={{ x: 1, y: 1 }}
                          style={{
                            borderRadius: 8,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            borderWidth: 0.8,
                            borderColor: "#374151",
                            width:
                              deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                                ? 156
                                : 181,
                            height: 196,
                            padding: 11,
                            paddingHorizontal: 16,
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          <View
                            style={{
                              gap: 5,
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "row",
                            }}
                          >
                            <Text style={AppFontStyle.BOLD_ANYBODY_12}>
                              Available
                            </Text>
                            <Text
                              style={
                                deviceSize === DEVICE_SIZES.XS ||
                                deviceSize === DEVICE_SIZES.SM
                                  ? AppFontStyle.BOLD_ANYBODY_24
                                  : AppFontStyle.BOLD_ANYBODY_28
                              }
                            >
                              {sellBeltsData.value}
                            </Text>
                          </View>
                          <Image
                            source={sellBeltsData.image}
                            style={[
                              {
                                width:
                                  deviceSize === DEVICE_SIZES.XS ||
                                  deviceSize === DEVICE_SIZES.SM
                                    ? 156
                                    : 181,
                                height:
                                  deviceSize === DEVICE_SIZES.XS ||
                                  deviceSize === DEVICE_SIZES.SM
                                    ? 118
                                    : 136,
                                resizeMode: "contain",
                              },
                            ]}
                          />
                        </LinearGradient>
                        <View style={styles.counterWrapper}>
                          <TouchableOpacity
                            style={[
                              styles.button,
                              count === 0 && styles.disabledButton,
                            ]}
                            onPress={decrement}
                            disabled={count === 0}
                          >
                            <Image
                              source={AppImages.icMinusIcon}
                              style={{
                                width: 20,
                                height: 3,
                                tintColor: AppColors.purple_453B50,
                              }}
                            />
                          </TouchableOpacity>
                          <Text
                            style={
                              deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                                ? AppFontStyle.BOLD_ANYBODY_24
                                : AppFontStyle.BOLD_ANYBODY_28
                            }
                          >
                            {count}
                          </Text>
                          <TouchableOpacity
                            style={[
                              styles.button,
                              count === sellBeltsData.value &&
                                styles.disabledButton,
                            ]}
                            onPress={increment}
                            disabled={count === sellBeltsData.value}
                          >
                            <Image
                              source={AppImages.icPlusIcon}
                              style={{
                                width: 20,
                                height: 20,
                                tintColor: AppColors.purple_453B50,
                              }}
                            />
                          </TouchableOpacity>
                        </View>
                      </View>
                      <View>
                        <Text
                          style={{
                            fontSize:
                              deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                                ? 80
                                : 128,
                            fontWeight: 600,
                            color: AppColors.white,
                          }}
                        >
                          =
                        </Text>
                      </View>
                      <View style={{ gap: 8 }}>
                        <Text
                          style={
                            deviceSize === DEVICE_SIZES.XS ||
                            deviceSize === DEVICE_SIZES.SM
                              ? AppFontStyle.SEMIBOLD_ANYBODY_14
                              : AppFontStyle.SEMIBOLD_ANYBODY_18
                          }
                        >
                          Credit Amount
                        </Text>
                        <View
                          style={{
                            width:
                              deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                                ? 105
                                : 136,
                            padding:
                              deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                                ? 18
                                : 24,
                            backgroundColor: AppColors.black_040404,
                            borderRadius: 20,
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={
                              deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM
                                ? AppFontStyle.SEMIBOLD_ANYBODY_24
                                : AppFontStyle.SEMIBOLD_ANYBODY_28
                            }
                          >
                            {count * sellBeltsData.sellPrice * 100}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                  <View style={{ alignItems: "center", gap: 16 }}>
                    <LinearGradient
                      colors={[
                        "rgba(31, 41, 55, 0.50)",
                        "rgba(17, 24, 39, 0.50)",
                      ]}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 1 }}
                      style={{
                        width:
                          deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                            ? "100%"
                            : 423,
                        height: 107,
                        padding: 16,
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: 8,
                        borderWidth: 0.8,
                        borderColor: "#374151",
                      }}
                    >
                      <Text
                        style={[
                          {
                            color: "#FFF",
                            fontSize: 16,
                            fontWeight: "700",
                            lineHeight: 18.48,
                            textAlign: "center",
                          },
                        ]}
                      >
                        Currency Value
                      </Text>
                      <Text
                        style={[
                          {
                            color: "#00D492",
                            fontSize: 32,
                            fontWeight: "800",
                            lineHeight: 36.96,
                            textAlign: "center",
                          },
                        ]}
                      >
                        £{(count * sellBeltsData.sellPrice).toFixed(2)}
                      </Text>
                    </LinearGradient>
                    <LinearGradient
                      colors={
                        isConvertingToCredit
                          ? ["#9CA3AF", "#6B7280"]
                          : ["#DC2626", "#991B1B"]
                      }
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 0 }}
                      style={{
                        borderRadius: 6,
                        opacity: isConvertingToCredit ? 0.7 : 1,
                      }}
                    >
                      <CommonButton
                        buttonStyle={styles.ConvertToCreditButtonStyle}
                        textStyle={[AppFontStyle.SEMIBOLD_ANYBODY_16, {}]}
                        title={
                          isConvertingToCredit
                            ? "Converting to Credits..."
                            : "Convert to Credits"
                        }
                        onTap={() => {
                          if (!isConvertingToCredit) {
                            paymentRequestSellAPI();
                          }
                        }}
                      />
                    </LinearGradient>
                  </View>
                </>
              )}

              {/* Lower Belt Tab Content */}
              {activeTab === 1 && (
                <>
                  <View
                    style={{
                      alignItems: "center",
                      gap: 24,
                      overflow: "visible",
                    }}
                  >
                    {/* From, Amount, To Section */}
                    <View
                      style={{
                        width: "100%",
                        maxWidth: 800,
                        flexDirection: "column",
                        gap: 16,
                        zIndex: 1,
                        overflow: "visible",
                      }}
                    >
                      {/* First Row: From and Amount (mobile) or All Three (desktop) */}
                      <View
                        style={{
                          flexDirection: "column",
                          gap: 16,
                        }}
                      >
                        {/* Labels Row 1 */}
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 16,
                          }}
                        >
                          <View style={{ flex: 1 }}>
                            <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_18]}>
                              From
                            </Text>
                          </View>
                          <View style={{ flex: 1 }}>
                            <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_18]}>
                              Amount of belt
                            </Text>
                          </View>
                          {(deviceSize !== DEVICE_SIZES.XS &&
                            deviceSize !== DEVICE_SIZES.SM) && (
                            <View style={{ flex: 1 }}>
                              <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_18]}>
                                To
                              </Text>
                            </View>
                          )}
                        </View>

                        {/* Controls Row 1 */}
                        <View
                          style={{
                            flexDirection: "row",
                            gap: 16,
                            alignItems: "flex-start",
                            zIndex: deviceSize === DEVICE_SIZES.XS ||
                              deviceSize === DEVICE_SIZES.SM ? 0 : 10,
                            overflow: "visible",
                          }}
                        >
                        {/* From Section - Display Only (No Dropdown) */}
                        <View style={{ flex: 1, zIndex: 0 }}>
                          <View
                            style={{
                              backgroundColor: "#1F2937",
                              borderRadius: 8,
                              borderWidth: 0.8,
                              borderColor: "#374151",
                              paddingHorizontal: 16,
                              paddingVertical: 12,
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                              maxHeight: 60,
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 12,
                              }}
                            >
                              <Image
                                source={sellBeltsData.image}
                                style={{
                                  width: 32,
                                  height: 32,
                                  resizeMode: "contain",
                                }}
                              />
                              <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_16]}>
                                {fromBelt}
                              </Text>
                            </View>
                          </View>

                          <Text
                            style={[
                              AppFontStyle.REGULAR_ANYBODY_12,
                              { marginTop: 8 },
                            ]}
                          >
                            You have {sellBeltsData.value} {fromBelt} belts
                          </Text>
                        </View>

                        {/* Amount Section */}
                        <View style={{ flex: 1, zIndex: 0 }}>
                          <View
                            style={{
                              backgroundColor: "#1F2937",
                              borderRadius: 8,
                              borderWidth: 0.8,
                              borderColor: "#374151",
                              paddingHorizontal: 12,
                              paddingVertical: 13,
                              maxHeight: 60,
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <TouchableOpacity
                              style={[
                                styles.button,
                                lowerBeltCount === 0 && styles.disabledButton,
                              ]}
                              onPress={decrementLowerBelt}
                              disabled={lowerBeltCount === 0}
                            >
                              <Image
                                source={AppImages.icMinusIcon}
                                style={{
                                  width: 20,
                                  height: 3,
                                  tintColor: AppColors.purple_453B50,
                                }}
                              />
                            </TouchableOpacity>
                            <Text style={[AppFontStyle.BOLD_ANYBODY_24]}>
                              {lowerBeltCount}
                            </Text>
                            <TouchableOpacity
                              style={[
                                styles.button,
                                lowerBeltCount >= sellBeltsData.value &&
                                  styles.disabledButton,
                              ]}
                              onPress={incrementLowerBelt}
                              disabled={lowerBeltCount >= sellBeltsData.value}
                            >
                              <Image
                                source={AppImages.icPlusIcon}
                                style={{
                                  width: 20,
                                  height: 20,
                                  tintColor: AppColors.purple_453B50,
                                }}
                              />
                            </TouchableOpacity>
                          </View>
                        </View>

                        {/* To Section - Desktop Only */}
                        {(deviceSize !== DEVICE_SIZES.XS &&
                          deviceSize !== DEVICE_SIZES.SM) && (
                          <View
                            style={{
                              flex: 1,
                              position: "relative",
                              zIndex: 100,
                              overflow: "visible",
                            }}
                          >
                          <TouchableOpacity
                            style={{
                              backgroundColor: "#1F2937",
                              borderRadius: 8,
                              borderWidth: 0.8,
                              borderColor: "#374151",
                              paddingHorizontal: 16,
                              paddingVertical: 12,
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              maxHeight: 60,
                            }}
                            onPress={() => {
                              setShowToDropdown(!showToDropdown);
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 12,
                              }}
                            >
                              <Image
                                source={getBeltImage(toBelt)}
                                style={{
                                  width: 32,
                                  height: 32,
                                  resizeMode: "contain",
                                }}
                              />
                              <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_16]}>
                                {toBelt}
                              </Text>
                            </View>
                            <Image
                              source={AppImages.icDownArrow}
                              style={{
                                width: 16,
                                height: 16,
                                resizeMode: "contain",
                                tintColor: AppColors.white,
                                transform: [
                                  {
                                    rotate: showToDropdown ? "180deg" : "0deg",
                                  },
                                ],
                              }}
                            />
                          </TouchableOpacity>

                          {/* To Dropdown */}
                          {showToDropdown && (
                            <View
                              style={{
                                position: "absolute",
                                top: 62,
                                left: 0,
                                right: 0,
                                backgroundColor: "#1F2937",
                                borderRadius: 8,
                                borderWidth: 0.8,
                                borderColor: "#374151",
                                zIndex: 9999,
                                elevation: 10,
                                maxHeight: 200,
                                shadowColor: "#000",
                                shadowOffset: { width: 0, height: 4 },
                                shadowOpacity: 0.3,
                                shadowRadius: 8,
                              }}
                              pointerEvents="auto"
                            >
                              {getAvailableToBelts(fromBelt).map(
                                (belt, index) => (
                                  <TouchableOpacity
                                    key={index}
                                    activeOpacity={0.7}
                                    style={{
                                      flexDirection: "row",
                                      alignItems: "center",
                                      gap: 12,
                                      paddingHorizontal: 16,
                                      paddingVertical: 12,
                                      borderBottomWidth:
                                        index !==
                                        getAvailableToBelts(fromBelt).length - 1
                                          ? 0.8
                                          : 0,
                                      borderBottomColor: "#374151",
                                    }}
                                    onPress={() => {
                                      setToBelt(belt);
                                      setShowToDropdown(false);
                                    }}
                                  >
                                    <Image
                                      source={getBeltImage(belt)}
                                      style={{
                                        width: 32,
                                        height: 32,
                                        resizeMode: "contain",
                                      }}
                                    />
                                    <Text
                                      style={[AppFontStyle.SEMIBOLD_ANYBODY_16]}
                                    >
                                      {belt}
                                    </Text>
                                  </TouchableOpacity>
                                )
                              )}
                            </View>
                          )}
                        </View>
                        )}
                      </View>
                      </View>

                      {/* Second Row: To Section - Mobile Only */}
                      {(deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM) && (
                        <View
                          style={{
                            flexDirection: "column",
                            gap: 16,
                            zIndex: 100,
                          }}
                        >
                          {/* To Label */}
                          <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_18]}>
                            To
                          </Text>

                          {/* To Dropdown */}
                          <View
                            style={{
                              position: "relative",
                              zIndex: 100,
                              overflow: "visible",
                            }}
                          >
                            <TouchableOpacity
                              style={{
                                backgroundColor: "#1F2937",
                                borderRadius: 8,
                                borderWidth: 0.8,
                                borderColor: "#374151",
                                paddingHorizontal: 16,
                                paddingVertical: 12,
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                maxHeight: 60,
                              }}
                              onPress={() => {
                                setShowToDropdown(!showToDropdown);
                              }}
                            >
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 12,
                                }}
                              >
                                <Image
                                  source={getBeltImage(toBelt)}
                                  style={{
                                    width: 32,
                                    height: 32,
                                    resizeMode: "contain",
                                  }}
                                />
                                <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_16]}>
                                  {toBelt}
                                </Text>
                              </View>
                              <Image
                                source={AppImages.icDownArrow}
                                style={{
                                  width: 16,
                                  height: 16,
                                  resizeMode: "contain",
                                  tintColor: AppColors.white,
                                  transform: [
                                    {
                                      rotate: showToDropdown ? "180deg" : "0deg",
                                    },
                                  ],
                                }}
                              />
                            </TouchableOpacity>

                            {/* Mobile Dropdown Menu */}
                            {showToDropdown && (
                              <View
                                style={{
                                  position: "absolute",
                                  top: 62,
                                  left: 0,
                                  right: 0,
                                  backgroundColor: "#1F2937",
                                  borderRadius: 8,
                                  borderWidth: 0.8,
                                  borderColor: "#374151",
                                  zIndex: 9999,
                                  elevation: 10,
                                  maxHeight: 200,
                                  shadowColor: "#000",
                                  shadowOffset: { width: 0, height: 4 },
                                  shadowOpacity: 0.3,
                                  shadowRadius: 8,
                                }}
                                pointerEvents="auto"
                              >
                                {getAvailableToBelts(fromBelt).map(
                                  (belt, index) => (
                                    <TouchableOpacity
                                      key={index}
                                      activeOpacity={0.7}
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: 12,
                                        paddingHorizontal: 16,
                                        paddingVertical: 12,
                                        borderBottomWidth:
                                          index !==
                                          getAvailableToBelts(fromBelt).length - 1
                                            ? 0.8
                                            : 0,
                                        borderBottomColor: "#374151",
                                      }}
                                      onPress={() => {
                                        setToBelt(belt);
                                        setShowToDropdown(false);
                                      }}
                                    >
                                      <Image
                                        source={getBeltImage(belt)}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          resizeMode: "contain",
                                        }}
                                      />
                                      <Text
                                        style={[AppFontStyle.SEMIBOLD_ANYBODY_16]}
                                      >
                                        {belt}
                                      </Text>
                                    </TouchableOpacity>
                                  )
                                )}
                              </View>
                            )}
                          </View>
                        </View>
                      )}
                    </View>

                    {/* Conversion Visual */}
                    <LinearGradient
                      colors={[
                        "rgba(31, 41, 55, 0.50)",
                        "rgba(17, 24, 39, 0.50)",
                      ]}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 1 }}
                      style={{
                        width: "100%",
                        maxWidth: 800,
                        padding: 24,
                        borderRadius: 8,
                        borderWidth: 1,
                        borderColor: "#374151",
                        alignItems: "center",
                        gap: 16,
                        zIndex: 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 24,
                        }}
                      >
                        <View style={{ alignItems: "center", gap: 8 }}>
                          <Image
                            source={sellBeltsData.image}
                            style={{
                              width: 80,
                              height: 80,
                              resizeMode: "contain",
                            }}
                          />
                          <Text style={[AppFontStyle.BOLD_ANYBODY_20]}>
                            {lowerBeltCount} {fromBelt}
                          </Text>
                        </View>

                        <View>
                          <Text
                            style={{
                              fontSize: 48,
                              fontWeight: "600",
                              color: AppColors.white,
                            }}
                          >
                            =
                          </Text>
                        </View>

                        <View style={{ alignItems: "center", gap: 8 }}>
                          <Image
                            source={getBeltImage(toBelt)}
                            style={{
                              width: 80,
                              height: 80,
                              resizeMode: "contain",
                            }}
                          />
                          <Text style={[AppFontStyle.BOLD_ANYBODY_20]}>
                            {calculateConvertedAmount()} {toBelt}
                          </Text>
                        </View>
                      </View>
                    </LinearGradient>

                    {/* Confirmation message */}
                    <View style={{ width: "100%", maxWidth: 800 }}>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_14,
                          { textAlign: "center", lineHeight: 20 },
                        ]}
                      >
                        You're about to exchange {lowerBeltCount} {fromBelt}{" "}
                        Belts for {calculateConvertedAmount()} {toBelt} Belts.
                        This action can't be undo
                      </Text>
                    </View>

                    {/* Confirm Exchange Button */}
                    <LinearGradient
                      colors={
                        isConvertingBelts
                          ? ["#9CA3AF", "#6B7280"]
                          : ["#DC2626", "#991B1B"]
                      }
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 0 }}
                      style={{
                        borderRadius: 6,
                        opacity: isConvertingBelts ? 0.7 : 1,
                      }}
                    >
                      <CommonButton
                        buttonStyle={styles.ConvertToCreditButtonStyle}
                        textStyle={[AppFontStyle.SEMIBOLD_ANYBODY_16, {}]}
                        title={
                          isConvertingBelts ? "Converting..." : "Confirm Exchange"
                        }
                        onTap={() => {
                          if (!isConvertingBelts) {
                            convertBeltsAPI();
                          }
                        }}
                      />
                    </LinearGradient>
                  </View>
                </>
              )}
            </View>
          </LinearGradient>
        </ScrollView>
      </View>

        {<ShowLoader showIndicater={showLoader} />}
      </Modal>

      {/* Belt Exchange Success Modal */}
      <BeltExchangeSuccessModal
        visible={showBeltExchangeSuccess}
        onClose={() => {
          setShowBeltExchangeSuccess(false);
          setShowModal(false);
        }}
        fromBeltImage={conversionSuccessData.fromBeltImage}
        toBeltImage={conversionSuccessData.toBeltImage}
        fromBeltName={conversionSuccessData.fromBeltName}
        toBeltName={conversionSuccessData.toBeltName}
        fromAmount={conversionSuccessData.fromAmount}
        toAmount={conversionSuccessData.toAmount}
      />

      {/* Credit Conversion Success Modal */}
      <CreditConversionSuccessModal
        visible={showCreditConversionSuccess}
        onClose={() => {
          setShowCreditConversionSuccess(false);
          setShowModal(false);
        }}
        beltImage={conversionSuccessData.fromBeltImage}
        beltName={conversionSuccessData.fromBeltName}
        beltAmount={conversionSuccessData.fromAmount}
        creditsAmount={conversionSuccessData.creditsAmount}
        currencyValue={conversionSuccessData.currencyValue}
      />
    </>
  );
  async function createNewTransaction(amount: string, belts: number, beltType: string) {
    try {
      const data = await createTransaction(accessToken, {
        amount: amount ? "£" + amount : "",
        tokens: 0,
        belts,
        beltType,
      });
      if (data.statusCode === 200 || data.statusCode === 201) {
        // Transaction created successfully
        console.log("Transaction created:", data.body.message);
      }
    } catch (error: any) {
      console.error("Transaction creation failed:", error.message);
    }
  }
  async function paymentRequestSellAPI() {
    const amount = (count * sellBeltsData.sellPrice).toFixed(2);
    const beltType = sellBeltsData?.title || "";
    const belts = count;
    const payoutDetails = {
      userID: userData.username,
      amount: amount,
      beltType: beltType,
      quotedAmount: count,
    };
    console.log("payoutDetails", payoutDetails);

    if (count === 0) {
      toast.error("You can't sell 0 belts");
      return;
    }

    setIsConvertingToCredit(true);

    try {
      const response = await fetchPaymentRequestSell(
        userData.AccessToken,
        payoutDetails
      );
      setIsConvertingToCredit(false);

      if (response.statusCode === 200) {
        await createNewTransaction(amount, belts, beltType);

        // Set success modal data
        setConversionSuccessData({
          fromBeltImage: sellBeltsData.image,
          toBeltImage: null,
          fromBeltName: sellBeltsData.title,
          toBeltName: "",
          fromAmount: count,
          toAmount: 0,
          creditsAmount: count * sellBeltsData.sellPrice * 100,
          currencyValue: `£${amount}`,
        });

        // Show success modal (don't close main modal yet - will close when success modal closes)
        setShowCreditConversionSuccess(true);
        setRefreshAPICall(true);
        setCount(0);
      } else {
        toast.error(
          response.error || "An error occurred during the payment request"
        );
      }
    } catch (error) {
      setIsConvertingToCredit(false);
      toast.error(error.message);
    }
  }
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    scrollView: {
      width: "100%", // Ensure the scroll view covers the full width
    },
    mainView: {
      width: "80%",
      maxWidth: 761,
      padding: 24,
      marginHorizontal: 40,
      marginVertical: 30,
      alignSelf: "center",
      borderRadius: 8,
      borderWidth: 1.6,
      borderColor: "rgba(239, 68, 68, 0.50)",
    },
    headerView: {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 16,
    },
    headerText: {
      color: AppColors.white,
      fontSize: 24,
    },
    ConvertToCreditButtonStyle: {
      paddingVertical: 10,
      paddingHorizontal: 24,
      shadowOpacity: 0,
      borderRadius: 6,
      backgroundColor: "transparent",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    // UpgradeButtonStyle: {
    //   paddingVertical: 12,
    //   paddingHorizontal: 24,
    //   shadowOpacity: 0,
    //   borderRadius: 10,
    //   height: 35,
    //   backgroundColor: AppColors.appViolentColor_6D08C3,
    //   borderColor: AppColors.appViolentColor_6D08C3,
    // },
    counterWrapper: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: AppColors.black_040404,
      borderRadius: 10,
      width: 181,
      height: 40,
      justifyContent: "space-between",
    },
    button: {
      width: 30,
      height: 30,
      borderRadius: 20,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "white",
    },
    disabledButton: {
      backgroundColor: "gray",
    },
    upgradeBtn: {
      flexDirection: "row",
      // backgroundColor: AppColors.appViolentColor_6D08C3,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 10,
      paddingHorizontal: 18,
      position: "relative",
      width: 175,
      height: 39,
      gap: 5,
    },
    tabButton: {
      flex: 1,
      paddingVertical: 12,
      paddingHorizontal: 16,
      borderRadius: 4,
      borderWidth: 0.5,
      borderColor: "#7B7B7B",
      backgroundColor: "transparent",
      alignItems: "center",
      justifyContent: "center",
    },
    activeTabButton: {
      borderRadius: 8,
      borderWidth: 1,
      borderColor: "#DC2626",
      backgroundColor: "#0C1119",
    },
    disabledTabButton: {
      opacity: 0.5,
      backgroundColor: "#1F2937",
      borderColor: "#4B5563",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      // mainView: {
      //   width: "45%",
      //   maxWidth: 500,
      // },
    },
    [DEVICE_SIZES.MD]: {
      // mainView: {
      //   width: "50%",
      //   maxWidth: 400,
      // },
    },
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "60%",
        maxWidth: "auto",
        padding: 12,
        marginHorizontal: 10,
        marginVertical: 30,
        borderRadius: 8,
      },
      headerText: {
        fontSize: 22,
      },
      counterWrapper: { width: "100%" },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "90%",
        maxWidth: "auto",
        marginHorizontal: 10,
        marginVertical: 30,
        padding: 12,
        borderRadius: 8,
      },
      headerText: {
        fontSize: 22,
      },
      counterWrapper: { width: "100%" },
    },
  }
);
